// export {};

import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface SettingsPrintersProps {
  openMenu(): void;
}

interface SelectedPrintersData {
  [key: string]: string;
}

const keyPrinters = '@tempedido:printers';

const SettingsPrinters: React.FC<SettingsPrintersProps> = ({ openMenu }) => {
  const [printers, setPrinters] = useState<string[]>([]);
  const [selectedPrinters, setSelectedPrinters] =
    useState<SelectedPrintersData>({});

  useEffect(() => {
    // Recupera impressoras selecionadas do localStorage ao carregar
    const savedPrinters = JSON.parse(localStorage.getItem(keyPrinters) || '{}');
    setSelectedPrinters(savedPrinters);

    if ((window as any).electronAPI && (window as any).electronAPI.getPrinters) {
      // Chama o Electron para listar impressoras instaladas
      (window as any).electronAPI.getPrinters().then((result: string[]) => {
        setPrinters(result);
      });
    }
  }, []);

  const handleChange = (printer: string, local: string) => {
    const tmp = { ...selectedPrinters };

    if (local === '') {
      delete tmp[printer];
    } else {
      tmp[printer] = local;
    }

    setSelectedPrinters(tmp);
  };

  const handleSave = () => {
    localStorage.setItem(keyPrinters, JSON.stringify(selectedPrinters));
    alert("Impressoras selecionadas salvas!");
  };

  return (
    <div className="nk-block">
      <div className="nk-block-head nk-block-between">
        <div className="nk-block-head-content">
          <h5 className="nk-block-title">Configurar Impressoras</h5>
          <div className="nk-block-des">
            <p>Configura o comportamento e a utilização das impressoras no Sistema Tem Pedido.</p>
          </div>
        </div>
        <div className="nk-block-head-content align-self-start d-lg-none">
          <Link
            to="#menu"
            className="toggle btn btn-icon btn-trigger mt-n1"
            data-target="userAside"
            onClick={openMenu}
          >
            <em className="icon ni ni-menu-alt-r" />
          </Link>
        </div>
      </div>
      <div className="card card-bordered">
        <div className="nk-data data-list">
            {printers.map(item => (
                <div
                    className="data-item"
                    data-toggle="modal"
                    data-target="#profile-edit"
                >
                    <div className="data-col">
                        <span className="data-label" style={{maxWidth: 130}}>
                            <em className="icon ni ni-printer mr-2" />
                            Impressora
                        </span>
                        <span className="data-value">
                          {item.trim().length > 80 ? `${item.trim().substring(0, 80)}...` : item.trim()}
                        </span>
                    </div>
                    <div className="data-col data-col-end" style={{minWidth: 200}}>
                        <div className="col-12 text-start">
                            
                                <div className="form-control-wrap ">
                                    <div className="form-control-select">
                                        <select
                                        className="form-control"
                                        value={selectedPrinters[item]}
                                        onChange={event => handleChange(item, event.target.value)}
                                        >
                                        <option value="">Selecionar...</option>
                                        <option value="0">Balcão</option>
                                        <option value="1">Cozinha</option>
                                        </select>
                                    </div>
                                </div>
                            
                        </div>
                    </div>
                </div>
            ))}
        </div>
      </div>
      
            <div className="form-group mt-4">
            <button
                type="submit"
                className="btn btn-lg btn-primary"
                onClick={handleSave}
            >
                Salvar
            </button>
            </div>
        
    </div>
  );
};

export default SettingsPrinters;
